import { Badge, ListItem, ListItemText, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { useMemo } from "react";
import { NavLink } from "react-router-dom";

import { SOURCE_TAGS } from "@kuva/ui-helpers";

import { useQuantification } from "~/hooks";

import { useAlarmListItemStyles } from "./styles";

export const AlarmListItem = ({
  alarm,
  selectedAlarm,
  selectedOrg,
  selectedCamera
}) => {
  const quantificationData = useQuantification(alarm);
  const { hasNoDistance, hasQuantification, isSourceValidForQuantification } =
    quantificationData || {};

  const leakSourceCode = useMemo(
    () =>
      Object.values(SOURCE_TAGS).find(
        tag => tag.name.toLowerCase() === alarm?.source?.toLowerCase()
      )?.code ?? "N/A",
    [alarm?.source]
  );

  const { classes } = useAlarmListItemStyles({
    alarm,
    hasQuantification,
    hasNoDistance,
    selectedAlarm,
    isSourceValidForQuantification
  });

  return (
    <ListItem
      component={NavLink}
      key={alarm.id}
      data-testid="alarm-list-item"
      to={`/alarms/${selectedOrg?.id}/${selectedCamera?.deviceId}/${alarm.id}/${alarm?.streamId}`}
      className={classes.listItem}
    >
      <ListItemText
        primaryTypographyProps={{
          className: classes.primaryTypography
        }}
      >
        {alarm.start.substring(11, 16)}–{alarm.end.substring(11, 16)}
        <Tooltip title={alarm?.source}>
          <span>- {leakSourceCode}</span>
        </Tooltip>
        {alarm?.falseAlarm && (
          <Badge className={classes.badge} badgeContent="FP" />
        )}
        <span className={classes.poiLabel}>
          [{Math.round(alarm?.poiOrientation) ?? "All"}]
        </span>
      </ListItemText>
    </ListItem>
  );
};

AlarmListItem.propTypes = {
  alarm: PropTypes.object.isRequired,
  selectedAlarm: PropTypes.object,
  selectedOrg: PropTypes.object,
  selectedCamera: PropTypes.object
};
